<img #profilePicture [src]="profilePictureSource" [alt]="profilePictureAltText">